<template lang="pug">
	PopupBody.audio-tracker-insertion--details.space-large
		Loader(v-if="!isJoditRendered", :fullscreen="true")
		.flex-col.space-large(:class="{ 'disabled-controls': !isJoditRendered }")
			.flex-row.justify.space-large.wrap.layout-main
				.left.flex-col
					template(v-if="!ssmlOnly")
						.flex-row.grey.upper.small-font.margin-top(
							:class="{'reverse': isRTL}"
						) {{$tCaption('Title')}}
						DxTextBox(
							:value.sync="record.name"
							:rtl-enabled="isRTL"
						)
					.flex-col.space(id="jodit-editor")
						.flex-row.justify.space
							.flex-row.space.margin-top(
								:class="{'reverse': isRTL}"
							)
								DxButton(:text="$tCaption('Text')", @click="() => setMode('text')", type="default", :styling-mode="isSSML ? 'text' : 'contained'")
								DxButton(:text="$tCaption('SSML')", @click="() => setMode('ssml')", type="default", :styling-mode="isSSML ? 'contained' : 'text'")
							.flex-col.justify-end
								.flex-row.ssml-actions-button
									DxButton(v-if="record && record.lastTtsLogId", icon="info", :hint="$tCaption('TTS Info')", @click="showTtsInfo", type="default", styling-mode="text", :activeStateEnabled="false", :focusStateEnabled="false")
									DxButton(icon="growfont", :hint="$tCaption('Grow font')", @click="zoomProp.value *= 1.2", type="default", styling-mode="text", :activeStateEnabled="false", :focusStateEnabled="false")
									DxButton(icon="shrinkfont", :hint="$tCaption('Shrink font')", @click="zoomProp.value /= 1.2", type="default", styling-mode="text", :activeStateEnabled="false", :focusStateEnabled="false")
									DxButton(icon="fullscreen", :hint="$tCaption('Fullscreen')", @click="$emit('toggle-fullscreen')", type="default", styling-mode="text", :activeStateEnabled="false", :focusStateEnabled="false")
						JoditEditor(
							v-if="!isSSML && isJoditRendered",
							ref="joditEditor",
							:config="joditConfig",
							:class="{ 'mod--rtl':isRTL, 'disabled-controls': voiceDetailsLoading }"
							:isRTL="isRTL",
							v-model="ssml",
							:buttons="['source', 'undo', 'redo']",
							:extraButtons="getCustomJoditButtons()", @paste="onJoditPaste", @dbl-click="onJoditElemDblClick", @click="onJoditElemClick",
							:zoom="zoomProp.value",
							:height="editorHeight"
						)
						Loader(v-if="!isJoditRendered && !voiceStylesFiltered" :text="$tCaption('Loading') + '...'")
						DxTextArea(v-if="isSSML", :value="record.pureSSML", @value-changed="v => onPureSSMLChanged(v.value)" :height="240", valueChangeEvent="input")
						EditorContextMenu(ref="contextMenu", :insertionDetails="self", @used-services-change="v => usedServices = v", :predefinedUsedServices="predefinedUsedServices", :preventContextMenuCustomProcess="preventContextMenuCustomProcess",
							:customContextMenuItems="customContextMenuItemsJoined", :forceTemplateFields="allowKeyEditing")
						EditorContextMenu(ref="dataContextMenu", :insertionDetails="self", target=".jodit-ui-group__data", :predefinedUsedServices="predefinedUsedServices", :preventContextMenuCustomProcess="preventContextMenuCustomProcess",
							:customContextMenuItems="customContextMenuItemsJoined", :forceTemplateFields="allowKeyEditing")
						.flex-row.justify.space
							.flex-row.align-center.space
								slot(name="editor")
								DxCheckBox(v-if="!ssmlOnly && track && !track.__isSubTrack", :text="$tCaption('Preload audio')", :hint="$tCaption('Immediate load audio on every change')", :value.sync="preloadAudio")
							.flex-row.align-center.space
								Loader(v-if="isPreloading", :text="$tCaption('Pre-loading audio')", :size="18")
				.right.flex-col.insertion-info(v-if="!hideVoiceSelection", :class="{ 'disabled-controls': readonly }")
					template(v-if="record.parentId")
						.grey.upper.small-font.margin-top {{$tCaption('Rule')}}
						Dropdown(
							:getTotal="(data) => null",
							:getItems="(data) => data",
							:getData="loadRules",
							:columns="[{ dataField: 'Name', caption: $tCaption('Rule') }]",
							displayExpr="Name",
							valueExpr="Oid",
							:placeholder="$tCaption('Rule')",
							v-model="record.eventRuleId",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:searchVisible="true",
							:multiple="false",
							:rtl-enabled="isRTL",
							:preloadedObjects="[record.eventRule]",
							@select-data="v => record.eventRule = v")
					.flex-row.grey.upper.small-font.margin-top(
						:class="{'reverse': isRTL}"
					) {{$tCaption('Voice')}}
					VoicesSelector(
						ref="voiceSelector",
						:audioContext="tracker.audioContext",
						:voice="record.voice",
						:language="record.language",
						:creativeIabCategories="creativeIabCategories",
						:filter="v => v && v.voice && !(v.voice.VoiceConversion || v.voice.Overdub)",
						@change="onVoiceSelect",
						@selected-voice="onSelectedVoice",
					)

					template(v-if="!actionsDisabled && creativeIabCategories && creativeIabCategories.length > 0 && matchedIabCategories.length > 0")
						.flex-col.margin-top
							.error-colored {{ $tCaption('The voice you have selected has restrictions for certain advertiser categories.') }}
							.error-colored {{ $tCaption('The voice may not be used for the categories you have selected.') }}
					template(v-else-if="!actionsDisabled && creativeIabCategories && creativeIabCategories.length === 0 && voiceRestrictedIabCategories.length > 0")
						.flex-col.margin-top
							.error-colored {{ $tCaption('The voice you have selected has restrictions for certain advertiser categories.') }}
							.error-colored {{ $tCaption('Please select the applicable IAB Categories for the Creative.') }}
					template(v-if="ssmlEditorVoiceStyles && ssmlEditorVoiceStyles.length")
						.flex-row.grey.upper.small-font.margin-top(
							:class="{'reverse': isRTL}"
						) {{$tCaption('Voice style')}}
						DxSelectBox(:value.sync="record.voiceStyle", :data-source="ssmlEditorVoiceStyles" displayExpr="label" valueExpr="id" :showClearButton="true")
					.flex-row.grey.upper.small-font.margin-top(
						:class="{'reverse': isRTL}"
					) {{$tCaption('Rate')}} {{formatNumber(rateSsmlSupported ? record.rate : track.playbackRate, '#0.0#')}}
					DxSlider(v-if="rateSsmlSupported", :value.sync="record.rate", :min="0.5", :max="2", :show-spin-buttons="true", :step="0.01", :show-range="false", :rtl-enabled="isRTL")
					DxSlider(v-else, :value.sync="track.playbackRate", :min="0.5", :max="2", :show-spin-buttons="true", :step="0.01", :show-range="false", :rtl-enabled="isRTL")
					.flex-row.grey.upper.small-font.margin-top(
						:class="{'reverse': isRTL}"
					) {{$tCaption('Pitch')}} {{formatNumber(pitchSsmlSupported ? record.pitch : track.pitchRate, '#0.0#')}}
					DxSlider(v-if="pitchSsmlSupported", :value.sync="record.pitch", :min="0", :max="2", :show-spin-buttons="true", :step="0.01", :show-range="false", :rtl-enabled="isRTL")
					DxSlider(v-else, :value.sync="track.pitchRate", :min="0", :max="2", :show-spin-buttons="true", :step="0.01", :show-range="false", :rtl-enabled="isRTL")
					DxButton.margin-top(v-if="supportAllSSMLTags", icon="fas fa-arrows-left-right-to-line", :text="$tCaption('Silence settings')", @click="$refs.silenceSettings.show()")
					.margin-top(v-if="isElevenLabs")
						SSMLElevenLabsSettings(:record="record")
					.margin-top(v-if="isPlayHt")
						SSMLPlayHtSettings(:record="record")
					.margin-top(v-if="isAzureNeuralHD")
						SSMLAzureNeuralHDSettings(:record="record", @ssml-changed="v => ssml = v")
					template(v-if="availableVoiceTypeModels.length")
						.flex-row.grey.upper.small-font.margin-top(:class="{'reverse': isRTL}") {{$tCaption('Model')}}
						DxSelectBox(:value.sync="voiceTypeModel", :data-source="availableVoiceTypeModels" displayExpr="Name" valueExpr="Code")
					DxCheckBox.margin-top(v-if="adjustTrackLengthVisible", :value.sync="adjustSubTrackLengthToParent", :text="$tCaption('Adjust subtracks to match main track length')")
					a.margin-top.flex-row.space.align-center(v-if="record.hasExcelFileUploaded", @click="downloadSubTracksExcel") 
						fas(:icon="isDownloadingExcelFile ? 'spinner' : 'download'", :spin="isDownloadingExcelFile")
						span {{$tCaption('Download sub-tracks source file')}}
					.margin-top(v-if="$scopedSlots['right-settings']")
						slot(name="right-settings", :data="{ record }")
					.flex-row.font-small.accent-color(v-if="limitPeriodText")
						span {{limitPeriodText}}
		.flex-row.space.align-center(
			v-if="!ssmlOnly",
			slot="actions-left"
			:class="{'reverse': isRTL}"
		)
			DxButton(v-if="isPlaying != 1",	:rtl-enabled="isRTL", :text="$tCaption('Play text')", type="default", icon="fas fa-play", :disabled="actionsDisabled || isPreloading", @click="startPlayCreative(true, true)")
			DxLoadIndicator(v-if="isPlaying > 0", :rtl-enabled="isRTL", :height="20", :width="20")
			DxButton(v-if="isPlaying != 2", :rtl-enabled="isRTL", :text="$tCaption('Play mix')", type="default", icon="fas fa-play", :disabled="actionsDisabled || isPreloading", @click="startPlayCreative(void 0, true)")
			DxButton(v-if="isPlaying", :rtl-enabled="isRTL", :text="$tCaption('Stop', '@actions')", type="normal", icon="fas fa-stop", @click="() => { stopPlayCreative(); }")
			DxButton(:rtl-enabled="isRTL", :text="$tCaption('Reset', '@actions')", type="normal", icon="fas fa-times", :disabled="actionsDisabled || !!isPlaying || readonly", @click="() => resetSsml()",)
		.flex-row.space(
			v-if="!ssmlOnly",
			:slot="'actions-right'"
			:class="{'reverse': isRTL}"
		)
			DxButton(v-if="selectedVoiceDetails && needToUpdateIabCategories && !voiceDetailsLoading" type="danger", :text="$tCaption('Update Iab Categories', '@actions')", :disabled="actionsDisabled || readonly", @click="updateIabCategories")
			DxButton(v-if="!record.isNew", :rtl-enabled="isRTL", :text="$tCaption('Remove')", type="danger", icon="fas fa-trash", :disabled="actionsDisabled || readonly", @click="remove")
			DxButton(v-if="!limitedByIabCategories && !voiceDetailsLoading" :rtl-enabled="isRTL", :text="$tCaption('Save', '@actions')", type="success", icon="fas fa-check", :disabled="actionsDisabled || readonly" @click="save")
			DxButton(:rtl-enabled="isRTL", :text="$tCaption('Cancel', '@actions')", icon="fas fa-times", @click="$emit('cancel')")

		Popup(v-if="editingTag === 'prosody' && editingAttribute === 'pitch'", :popupVisible="true", :width="720", :autosize="true", :title="$tCaption('Pitch')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLPitchEditor(ref="pitch", v-if="editingTag === 'prosody' && editingAttribute === 'pitch'", :value="editingNodeInfo.values.pitch", @change="v => editingNodeInfo.values.pitch = v")

		Popup(v-if="editingTag === 'prosody' && editingAttribute === 'volume'", :popupVisible="true", :width="580", :autosize="true", :title="$tCaption('Volume')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				DxSlider(:value.sync="editingNodeInfo.values.volume", :min="0", :max="100", :show-spin-buttons="true", :step="1", :tooltip="joditVolume.tooltip", :show-range="false")

		Popup(v-if="editingTag === 'break'", :popupVisible="true", :width="340", :autosize="true", :title="$tCaption('Break (ms)')", :closeOnOutsideClick="false")
			.flex-col.space
				DxSlider(:value.sync="editingBreakTime", :min="0", :max="2000", :show-spin-buttons="true", :step="10", :tooltip="joditBreak.tooltip",:show-range="false")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="applyEditTag")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editingTag = null")

		Popup(v-if="editingTag === 'adthos:audio'", :popupVisible="true", :width="640", :autosize="true", :title="$tCaption('Non-Lexical Conversational Sounds')", :closeOnOutsideClick="false", @show="saveSSML", @hiding="restoreSSML")
			.flex-col.full-height.justify.NLCSounds
				.flex-col.justify-center.align-center.flex-1(v-show="selectedVoiceDetailsLoader")
					.loader-icon
						i.fas.fa-circle-notch.fa-spin

				.flex-col.space-large(v-if="!selectedVoiceDetailsLoader && selectedVoiceNLCSounds.length")
					.flex-row.space-large
						.flex-col.flex-1
							DxSelectBox(:data-source="selectedVoiceNLCSounds" :value="editingNodeInfo.values.id" display-expr="NlcsType.Description" value-expr="Oid" :show-clear-button="true"
								placeholder="Choose sound" @value-changed="v => selectNLCSound(v.value)" :disabled="voiceDetailsLoading"
							)
						DxButton(:text="$tCaption('Play')", type="default", icon="fas fa-play", :disabled="!editingNodeInfo.values.id", @click="() => playNLCSound()")
					.flex-col.space
						.upper.grey.font-small {{ $tCaption('Intensity') }}
						DxSlider(:value.sync="editingNodeInfo.values.intensity", :min="0", :max="100", title="Intensity" :label="joditNonLexicalSounds.intensityLabel"
							:show-spin-buttons="true", :step="1", :tooltip="joditNonLexicalSounds.intensityTooltip", :show-range="false" :disabled="!editingNodeInfo.values.id || voiceDetailsLoading"
						)
				.flex-col.justify-center.align-center.flex-1(
					v-if="!this.selectedVoiceDetailsLoader && !selectedVoiceNLCSounds.length"
				)
					div {{ $tCaption('The selected voice does not contain non-lexical sounds.') }}
					div {{ $tCaption('Please choose another.') }}
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", :disabled="!editingNodeInfo.values.id", @click="applyEditTag")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editingTag = null")

		Popup(v-if="editingTag === 'prosody' && editingAttribute === 'contour'", :popupVisible="true", :width="960", :height="540", :title="$tCaption('Intonation contour')")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLContourEditor(
					v-if="editingTag === 'prosody' && editingAttribute === 'contour'",
					ref="contour",
					:value="editingNodeInfo.values.contour",
					:text="editingNodeInfo.text",
					@change="v => editingNodeInfo.values.contour = v",
					@play-original="playOriginal"
				)
				.flex-row.space.align-center(slot="actions-left")
					DxButton(v-if="editingTag === 'prosody' && editingAttribute === 'contour'", :text="$tCaption('Clear')", type="danger", icon="fas fa-trash", @click="() => { $refs.contour.clearPoints(); }")

		Popup(v-if="editingTag === 'phoneme'", :popupVisible="true", :width="640", :height="320", :title="$tCaption('Pronunciation')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLPronunciationEditor(ref="pronunciation", v-if="editingTag === 'phoneme'", :value="editingNodeInfo.values", :text="editingNodeInfo.text", @change="v => editingNodeInfo.values = v")

		Popup(v-if="editingTag === 'say-as'", :popupVisible="true", :width="580", :height="320", :title="$tCaption('Reading rule')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLReadingRulesEditor(ref="readingRules", v-if="editingTag === 'say-as'", :value="editingNodeInfo.values", :text="editingNodeInfo.text", @change="v => editingNodeInfo.values = v")

		Popup(v-if="editingTag === 'adthos:wbs'", :popupVisible="true", :width="(editingNodeInfo.values.hideServiceSelection ? 540 : 740) + (editingNodeInfo.values.paramsListOptionsVisible ? 500 : 0)", 
			:height="480", :title="editingNodeInfo.values.title || $tCaption('Dynamic data')", :closeOnOutsideClick="false", :autosize="true")
			.flex-col.space
				SSMLWebServiceEditor(ref="wbsEditor", v-if="editingTag === 'adthos:wbs'", :value="editingNodeInfo.values", @change="v => editingNodeInfo.values = v", 
					:templateFields="templateFields", :allowKeyEditing="allowKeyEditing", :usedServices="usedServices", @create-template-field="(tf, cb) => $emit('create-template-field', tf, cb)", 
					@show-params-list-options="v => $set(editingNodeInfo.values, 'paramsListOptionsVisible', v)", :preventStoreParameters="preventStoreParameters")
			template(slot="actions-left")
				DxCheckBox(:text="$tCaption('Change all occurrences in this creative')", :value.sync="editingNodeInfo.values.replaceAllOccurencies")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="(e) => validate(e, () => applyEditTag(), () => $refs.wbsEditor.validate())")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editingTag = null")

		Popup(v-if="prePurchasePopupVisible && selectedVoice", :popupVisible="prePurchasePopupVisible" :width="400", :height="300", :title="$tCaption('To Premium Subscription')", :closeOnOutsideClick="true" @hiding="prePurchasePopupVisible = false")
			.flex-col.space
				span(v-html="premiumSubsctiptionMessage")
			template(slot="actions-right")
				DxButton(:text="$tCaption('OK', '@actions')", type="default", @click="purchaseSubscription")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="prePurchasePopupVisible = false")

		Popup(v-if="editingTag === 'prosody' && editingAttribute === 'rate'", :popupVisible="true", :width="640", :height="320", :title="$tCaption('Rate')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLReadingRate(ref="readingRate", v-if="editingTag === 'prosody' && editingAttribute === 'rate'", :value="editingNodeInfo.values.rate", @change="v => editingNodeInfo.values.rate = v")

		SelectSubscriptionPopup(ref="SubscriptionPopup" @reload-parent-page="$refs.mySubscriptions.reload()" :selected-plan-index="1")

		Popup(v-if="editingTag === 'adthos:variativetext'" :popupVisible="true", :width="920", :height="780", :title="$tCaption('Variative text')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self", :playActionsHidden="true")
				SSMLVariativeText(ref="variativeText", v-if="editingTag === 'adthos:variativetext'", :value="editingNodeInfo.values", @change="v => editingNodeInfo.values = v",
					:templateFields="templateFields", :allowKeyEditing="allowKeyEditing", @create-template-field="(tf, cb) => $emit('create-template-field', tf, cb)")

		Popup(v-if="joditLexicon.visible", :popupVisible="joditLexicon.visible", :width="520", :height="540", :title="$tCaption('Lexicons')", :closeOnOutsideClick="false")
			.flex-col.space
				SSMLLexiconEditor(@change="v => loadLexicons()", :lexiconType="0", :addToLexicon="joditLexicon.addToLexicon", @close="joditLexicon.visible = false")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="joditLexicon.visible = false")
			
		Popup(v-if="joditCustomTNs.visible", :popupVisible="joditCustomTNs.visible", :width="520", :height="540", :title="$tCaption('Custom TN')", :closeOnOutsideClick="false")
			.flex-col.space
				SSMLLexiconEditor(@change="v => loadCustomTNs()", :lexiconType="1", :addToLexicon="joditLexicon.addToLexicon", @close="joditCustomTNs.visible = false")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="joditCustomTNs.visible = false")

		Popup(v-if="joditStylizer.visible", :popupVisible="true", :width="520", :height="540", :title="$tCaption('Stylizers')", :closeOnOutsideClick="false")
			.flex-col.space
				SSMLStylizerEditor(@change="v => loadStylizers()", @close="joditStylizer.visible = false")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="joditStylizer.visible = false")

		Popup(v-if="editingTag === 'mstts:express-as' && editingAttribute === 'styledegree'", :popupVisible="true", :width="520", :height="240", :title="$tCaption('Style degree')", :closeOnOutsideClick="false")
			DetailToolPopupBody(slot="body", :src="self")
				SSMLStyleDegreeEditor(ref="styleDegree", v-if="editingTag === 'mstts:express-as' && editingAttribute === 'styledegree'", :value="editingNodeInfo.values.styledegree", @change="v => editingNodeInfo.values.styledegree = v")
		
		SSMLTextPronunciationTool(ref="textPronunciationTool", :text="joditTextPronunciationTool.value", :voice="actualVoice", @save="onPronunciationToolSave", @save-phoneme="onPronunciationToolSave")

		SSMLSayAsTool(ref="sayAsTool", :voice="selectedVoice", @save="onSayAsToolSave")

		SSMLSilenceSettings(ref="silenceSettings", :ssml="getPreparedSsml", @save="onSilenceSettingsChange")

		SSMLVoiceConversionTool(ref="voiceConversionTool", :voice="selectedVoice", @save="onVoiceConversionSave", @voice-change="v => onVoiceSelect(v)")

		SSMLOverdubbingTool(ref="overdubbingTool", :voice="selectedVoice", @save="onOverdubbingSave", :tracker="tracker")

		Popup(v-if="ttsInfoPopupVisible", :popupVisible="ttsInfoPopupVisible", :width="720", :autosize="true", :title="$tCaption('TTS Log')")
			.flex-col.space
				TtsLogDetail(v-if="ttsInfoPopupVisible", :id="record.lastTtsLogId")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="ttsInfoPopupVisible = false")

		slot
</template>

<script>
	import $ from 'jquery';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import { DxSlider } from 'devextreme-vue/slider';
	import DxButton from 'devextreme-vue/button';
	import cognitiveArrays from './cognitive-arrays';
	import Data from 'app-core/Data';
	import { DxPopup } from 'devextreme-vue/popup';
	import SSMLEditor from './InsertionSSMLEditor.vue';
	import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
	import _ from 'lodash';
	import storage from 'storage';
	import PopupBody from 'app-core/PopupBody.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import SSMLPitchEditor from './SSMLPitchEditor.vue';
	import SSMLContourEditor from './SSMLContourEditor.vue';
	import SSMLPronunciationEditor from './SSMLPronunciationEditor.vue';
	import SSMLReadingRulesEditor from './SSMLReadingRulesEditor.vue';
	import SSMLWebServiceEditor from './SSMLWebServiceEditor.vue';
	import Popup from 'app-core/Popup.vue';
	import JoditEditor from './JoditEditor.vue';
	import DataSource from "devextreme/data/data_source";
	import Loader from "app-core/Loader";
	import SelectSubscriptionPopup from "@/view/company/SelectSubscriptionPopup";
	import VoicesSelector from './VoicesSelector.vue';
	import ssmlHelper from './ssml-helper';
	import SSMLReadingRate from './SSMLReadingRate.vue';
	import SSMLVariativeText from './SSMLVariativeText.vue';
	import SSMLLexiconEditor from './SSMLLexiconEditor.vue';
	import EditorContextMenu from './EditorContextMenu.vue';
	import SSMLTextPronunciationTool from './SSMLTextPronunciationTool.vue';
	import { saveAs } from 'file-saver';
	import SSMLSayAsTool from './SSMLSayAsTool.vue';
	import SSMLStyleDegreeEditor from './SSMLStyleDegreeEditor';
	import SSMLSilenceSettings from './SSMLSilenceSettings.vue';
	import SSMLVoiceConversionTool from './SSMLVoiceConversionTool.vue';
	import SSMLOverdubbingTool from './SSMLOverdubbingTool.vue';
	import TtsLogDetail from 'view/ttsLog/Detail.vue';
	import SSMLStylizerEditor from './SSMLStylizerEditor.vue';
	import DetailToolPopupBody from './DetailToolPopupBody.vue';
	import SSMLElevenLabsSettings from './SSMLElevenLabsSettings.vue';
	import SSMLPlayHtSettings from './SSMLPlayHtSettings.vue';
	import SSMLAzureNeuralHDSettings from './SSMLAzureNeuralHDSettings.vue';

	export default {
		translationCategory: 'insertion.Detail',
		name: 'audio-editor-insertion--details',
		components: {
			Loader, DxTextBox, DxTextArea, DxSelectBox, DxSlider, DxButton, DxPopup, DxLoadIndicator, PopupBody, Dropdown,SSMLContourEditor,
			Popup, SSMLPronunciationEditor, SSMLReadingRulesEditor,	SSMLWebServiceEditor, JoditEditor, SelectSubscriptionPopup,	VoicesSelector,	DxCheckBox,	SSMLReadingRate,
			SSMLVariativeText, EditorContextMenu, SSMLLexiconEditor, SSMLTextPronunciationTool, SSMLSayAsTool, SSMLStyleDegreeEditor, SSMLSilenceSettings, SSMLVoiceConversionTool,
			SSMLOverdubbingTool, SSMLPitchEditor, TtsLogDetail, SSMLStylizerEditor, DetailToolPopupBody, SSMLElevenLabsSettings, SSMLPlayHtSettings, SSMLAzureNeuralHDSettings
		},
		mixins: [cognitiveArrays, Data.mixin, SSMLEditor],
		props: [
			'srcAudio', 'item', 'getSsml', 'tracker', 'track', 'ssmlOnly', 'hideVoiceSelection', 'predefinedUsedServices', 'preventContextMenuCustomProcess',
			'creativeIabCategories', 'excelColumns', 'excelDataVisible', 'templateFields', 'allowKeyEditing', 'readonly', 'customContextMenuItems', 'preventStoreParameters',
			'editorHeight'
		],
		data() {
			return {
				record: { ..._.clone(this.item), pureSSML: null },
				isSSML: false,
				isPlaying: 0,
				ssml: this.item.ssml || '',
				updatingRecordValues: false,
				isJoditRendered: false,
				prePurchasePopupVisible: false,
				selectedVoice: null,
				selectedVoiceDetails: null,
				selectedVoiceDetailsLoader: false,
				voiceDetailsLoading: false,
				adjustSubTrackLengthToParent: (this.track?.__parentTrack || this.track)?.insertion?.JsonConfig?.adjustSubTrackLengthToParent === true || false,
				arabicLang: [
					'Arabic',
					'Aramaic',
					'Azeri',
					'Dhivehi',
					'Maldivian',
					'Hebrew',
					'Kurdish',
					'Sorani',
					'Persian',
					'Farsi',
					'Urdu',
				],
				excelDataItems: [],
				usedServices: [],
				isDownloadingExcelFile: false,
				isChanging: false,
				zoomProp: storage.prop('jodit_text_zoom', void 0, 1),
				isPreloading: false,
				ttsInfoPopupVisible: false,
				isLoading: 0
			};
		},
		computed: {
			actualVoice() {
				return this.voices.find(f => f.id === this.record?.voice && f.locale === this.record?.language) || this.voices.find(f => f.id === this.record?.voice);
			},
			premiumSubsctiptionMessage() {
				return this.$tCaption('To use the selected voice ("<b>VOICE_NAME</b>"), you need to purchase the Premium Subscription.<br><br>Buy subscription?').replace(/VOICE_NAME/g, this.selectedVoice?.text);
			},
			self() {
				return this;
			},
			voicesFiltered() {
				return new DataSource({
					store: this.getVoices(this.record.language),
					key: 'id',
					group: 'groupName'
				});
			},
			voiceStylesFiltered() {
				return this.getVoiceStyles(this.record.voice);
			},
			ssmlEditorVoiceStyles() {
				return this.selectedVoice?.voice?.VoiceStyles || [];
			},
			actionsDisabled() {
				return !this.selectedVoice;
			},
			adjustTrackLengthVisible() {
				return this.excelDataVisible || this.track?.__totalSubInsertions || (this.track?.__isSubTrack && !this.track?.id);
			},
			rootTrack() {
				return this.track?.__parentTrack || this.track;
			},
			selectedVoiceNLCSounds() {
				return this.selectedVoiceDetails?.NlcSounds || [];
			},
			recordLanguage() {
				return this.record?.language || null
			},
			selectedVoiceLanguage() {
				return this.selectedVoice?.language || {};
			},
			isRTL() {
				return this.arabicLang?.includes(this.selectedVoiceLanguage?.name);
			},
			voiceRestrictedIabCategories() {
				return (this.selectedVoiceDetails?.IabCategories || [])
					.reduce((acc, cat) => {
						return [
							...acc,
							{
								Code: cat.Code,
								Name: cat.Name,
								Oid: cat.Oid,
							},
							...(cat.SubCategories || []),
						]
					}, []) || [];
			},
			matchedIabCategories() {
				let creativeIab = [...(this.creativeIabCategories || [])].map(c => c.Oid);
				let voiceIab = [...this.voiceRestrictedIabCategories].map(c => c.Oid);

				return voiceIab.filter(c => creativeIab.includes(c)) || [];
			},
			needToUpdateIabCategories() {
				return this.voiceRestrictedIabCategories.length > 0 && this.creativeIabCategories?.length === 0;
			},
			limitedByIabCategories() {
				return this.matchedIabCategories.length > 0
					|| (this.voiceRestrictedIabCategories.length > 0 && this.creativeIabCategories?.length === 0);
			},
			customContextMenuItemsJoined() {
				const customActions = [];
				
				if (this.joditLexicon.lexicons?.length) {
					customActions.push(...[
						{	
							text: this.$tCaption('Actions'),
							template: 'service',
							__type: 'customFields',
							imageUrl: null,
							icon: 'list',
							items: 
							[
								{	
									text: this.$tCaption('Add to lexicon'),
									template: 'service',
									__type: 'customFields',
									imageUrl: null,
									icon: 'plus',
									items: 
									[
										...this.joditLexicon.lexicons.map(f => ({
											text: f?.Name,
											template: 'output',
											icon: 'f',
											action: () => {
												this.joditLexicon.visible = false;
												this.joditLexicon.addToLexicon = {
													grapheme: this.$Data.htmlToText(this.editor().selection?.html),
													lexicon: f
												};
												setImmediate(() => {
													if (this._isDestroyed) return;
													this.joditLexicon.visible = true;
												});
											},
											allowFieldValue: true,
											contextMenuVisible: true
										}))
									],
									contextMenuVisible: true
								}
							]
						}
					]);
				}
				return [
					...customActions,
					...(this.customContextMenuItems || [])
				]
			},
			preloadAudio: {
				get: function() {
					return this.track?.insertion?.JsonConfig?.preloadAudio || false;
				},
				set: function(v) {
					this.$set(this.track.insertion.JsonConfig, 'preloadAudio', v);
				}
			},
			limitPeriodText() {
				if (!this.item.activeFrom || !this.item.activeTo) return '';

				let periods = [];
				if (this.item.activeFrom) {
					periods.push(this.$tCaption('from DATE').replace(/DATE/g, this.$moment(this.item.activeFrom).format('L')));
				}
				
				if (this.item.activeTo) {
					periods.push(this.$tCaption('to DATE').replace(/DATE/g, this.$moment(this.item.activeTo).format('L')));
				}

				if (this.item.targets?.length) {
					if (this.item.targets.length === 1) {
						periods.push(this.$tCaption('in the TARGET time zone').replace(/TARGET/g, this.item.targets[0].Name));
					} else {
						periods.push(this.$tCaption('in the geo-target time zone'));
					}
				} else {
					periods.push(this.$tCaption('in the creative\'s time zone'));
				}

				return this.$tCaption('Active PERIODS').replace(/PERIODS/g, periods.join(' '));
			},
			supportAllSSMLTags() {
				return (this.record?.ttsProviderType || 0) == 0;
			},
			isElevenLabs() {
				return (this.record?.ttsProviderType || 0) == 2;
			},
			isPlayHt() {
				return (this.record?.ttsProviderType || 0) == 5;
			},
			isAzureNeuralHD() {
				return (this.selectedVoice?.voice?.VoiceType || 0) == 21;
			},
			pitchSsmlSupported() {
				return this.selectedVoice?.settings ? this.tagIsSupported('prosody', 'pitch') : this.supportAllSSMLTags;
			},
			rateSsmlSupported() {
				return this.selectedVoice?.settings ? this.tagIsSupported('prosody', 'rate') : this.supportAllSSMLTags;
			},
			editingBreakTime: {
				get: function () {
					let val = `${this.editingNodeInfo.values.time || ''}`;
					
					let floatVal = 0;
					if (!val.endsWith('ms') && val.endsWith('s')) {
						floatVal = parseFloat(this.editingNodeInfo.values.time) * 1000;
					} else {
						floatVal = parseFloat(this.editingNodeInfo.values.time);
					}

					return floatVal;
				},
				set: function(v) {
					this.editingNodeInfo.values.time = `${this.$Data.formatNumber((v || 0) / 1000, '#0.0#')}s`;
				},
				cache: false
			},
			availableVoiceTypeModels() {
				let models = (this.selectedVoice?.voice?.TtsModelCodes || this.selectedVoice?.voice?.TtsModelIds || '').split(',').map(f => `${f || ''}`.trim()).filter(f => f);
				return this.voiceTypeModels.filter(f => f.ProviderType === this.selectedVoice?.voice?.TtsProviderType
					&& (models.length === 0 || models.includes(f.Code) || models.includes(f.Oid))
				);
			},
			voiceTypeModel: {
				get: function() { return (this.record.voiceSettings || {}).VoiceModel; },
				set: function(v) {
					if (!this.record.voiceSettings) {
						this.$set(this.record, 'voiceSettings', {
							VoiceModel: null
						});
					}
					this.$set(this.record.voiceSettings, 'VoiceModel', v);
				}
			}
		},
		watch: {
			adjustSubTrackLengthToParent(v) {
				if (this.rootTrack)
					this.rootTrack.insertion.JsonConfig.adjustSubTrackLengthToParent = v;
			},
			'record.language'(v) {
				if (__DEBUG__)
					console.info('Lang changed', v);
				if (v) {
					storage.prop('ssmlLanguage').value = v;
				}
			},
			'record.voice'(v) {
				if (__DEBUG__)
					console.info('Voice style changed', v);
				if (this.updatingRecordValues) return;
				if (v) {
					if (!this.updatingRecordValues)
						this.record.voiceStyle = this.voiceStylesFiltered[0]?.id || null;
					this.isJoditRendered = false;
					this.$nextTick(() => {
						this.isJoditRendered = true;
						this.syncData('record');
					});
				} else {
					this.syncData('record');
				}
			},
			'record.voiceStyle'() {
				this.syncData('record');
				this.activateVoice(this.selectedVoice, true, this.record.voiceStyle);
			},
			'record.rate'() {
				this.syncData('record');
			},
			'record.pitch'() {
				this.syncData('record');
			},
			'item.audio'(v) {
				this.record.audio = v;
			},
			'record': {
				handler() {
					if (!this.isChanging) {
						this.$emit('change', this.record);
					}
				},
				deep: true
			},
			'ssml'(v) {
				this.record.ssml = v;
				if (this.preloadAudio) {
					this.$doPreloadAudio();
				}
				if (!this.$waitForSsmlChange) {
					this.syncData('ssml', 'ssml');
				} else {
					delete this.$waitForSsmlChange;
				}
			},
			'item.oid'() {
				this.isChanging = true;
				this.record = { ..._.clone(this.item), pureSSML: null };
				this.ssml = this.item?.ssml || '';
				setImmediate(() => this.isChanging = false);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.InsertionDetails = this;

			this.loadSpeechVoices(void 0, this.$storage.prop('ssmlLanguage').value)
				.then(() => {
					if (this.record?.isNew && !this.record.voice) {
						let voice = this.voices.filter(f => f.id === this.$storage.prop('ssmlVoice').value && f.locale === this.$storage.prop('ssmlLanguage').value)[0];
						if (!voice) {
							voice = this.voices.filter(f => f.id === this.$storage.prop('ssmlVoice').value)[0];
						}

						if (voice?.voice?.Oid && voice?.isCustom) {
							this.getVoiceDetails(voice)
								.then((details) => {
									if (__DEBUG__)
										console.log('matchedIabCategories', this.matchedIabCategories);

									if (!this.voiceRestrictedIabCategories.length
										|| (this.creativeIabCategories?.length > 0 && !this.matchedIabCategories.length)) {
										this.onVoiceSelect(voice, details);
									}
								});
						} else {
							if (voice)
								this.onVoiceSelect(voice);
						}
					}
					this.setDefaults();
				})
				.finally(() => this.isJoditRendered = true);

			this.loadLexicons();
			this.loadCustomTNs();
			this.loadStylizers();

			this.$doPreloadAudio = _.debounce(this.doPreloadAudio, 1000, {
				'leading': false,
				'trailing': true,
			});

			this.$eventsBus.$on('custom-voice-active', this.onCustomVoiceActive);
		},
		destroyed() {
			this.stopPlayCreative();
			delete this.$audio;
			delete this.$savedSSML;
			delete this.$syncRun;
			delete this.$waitForSsmlChange;

			this.$eventsBus.$off('custom-voice-active', this.onCustomVoiceActive);
		},
		methods: {
			setDefaults() {
				if (this.voiceTypeModel && !this.availableVoiceTypeModels.find(f => f.Code === this.voiceTypeModel)) {
					this.voiceTypeModel = null;
				}
				this.$nextTick(() => {
					if (!this.voiceTypeModel && this.availableVoiceTypeModels.length) {
						let def = this.availableVoiceTypeModels.find(f => f.IsDefault);
						if (def) {
							this.voiceTypeModel = def.Code;
						}
					}
				});
			},
			showTtsInfo() {
				this.ttsInfoPopupVisible = false;
				this.$nextTick(() => {
					this.ttsInfoPopupVisible = true;
				});
			},
			syncData(initiator, log) {
				if (!this.$syncRun) {
					this.$syncRun = true;

					if (__DEBUG__)
						console.debug(`Sync data ${initiator}: ${log}`);
					
					try {
						switch(initiator) {
							case 'ssml':
								{
									let doc = document.createElement('div');
									doc.innerHTML = this.ssml;

									let speak = doc.querySelector('speak');
									if (!speak) return;

									let voiceObj = speak?.querySelector('voice');
									if (!voiceObj) return;
									let voice = voiceObj.getAttribute('name');
									let mstts = voiceObj.querySelector(':scope > mstts\\:express-as');
									
									let prosody = (mstts ? mstts : voiceObj).querySelector(':scope > prosody');
									let voiceStyle = mstts?.getAttribute('style');
									let rate = prosody?.getAttribute('rate');
									let pitch = prosody?.getAttribute('pitch');
									
									let language = speak.getAttribute('xml:lang');
									let lang = prosody?.querySelector(':scope > lang');
									if (lang)
										language = lang.getAttribute('xml:lang');

									if (__DEBUG__)
										console.debug('Update record values initiator ssml', { voice, voiceStyle, language, rate, pitch, mstts, prosody, ssml: this.ssml });

									if (language) {
										this.record.language = language;
									}
									if (voice) {
										this.record.voice = voice;
									}
									if (voiceStyle) {
										this.record.voiceStyle = voiceStyle;
									}

									let hasRootProsody = ![...((mstts ? mstts : voiceObj).childNodes || [])].some(f => f.nodeType === 3);

									if (hasRootProsody) {
										if (rate && rate >= 0 && rate <= 3) {
											this.record.rate = parseFloat(rate) || 0;
										}

										if (pitch) {
											let pitchSign = pitch.slice(0, 1);
											let pitchValue = parseFloat(pitch.slice(1)) / 100;

											if (pitchValue && pitchValue <= 1 && pitchValue >= 0 && (pitchSign === '+' || pitchSign === '-')) {
												this.record.pitch = parseFloat(pitchSign === '+' ? pitchValue + 1 : 1 - pitchValue) || 0;
											}
										}
									}
								}
								break;
							case 'record':
								{
									if (this.$refs.joditEditor) {
										this.editor().value = ssmlHelper.prepareSsml(this.ssml, { ...this.record, sender: this })?.ssml;
										this.$refs.joditEditor.preformat();
									} else {
										this.record.pureSSML = ssmlHelper.prepareSsml(this.record.pureSSML, { ...this.record, sender: this })?.ssml;
									}

									if (__DEBUG__)
										console.debug('Update record values initiator record');
								}
								break;
						}
					} finally {
						this.$nextTick(() => {
							if (this._isDestroyed) return;
							this.$syncRun = false;
							if (this.$refs.joditEditor && initiator === 'record') {
								this.$refs.joditEditor.preformat();
							}
							this.$waitForSsmlChange = true;
						});
					}
				}
			},
			getPreparedSsml() {
				return ssmlHelper.prepareSsml(this.ssml, { ...this.record, sender: this })?.ssml;
			},
			onSilenceSettingsChange(silenceItems) {
				if (__DEBUG__)
					console.debug('onSilenceSettingsChange', { silenceItems });

				var ssml = ssmlHelper.prepareSsml(this.ssml, { ...this.record, sender: this })?.ssml;

				const doc = document.createElement('div');
				doc.innerHTML = ssml;

				const voice = doc.querySelector('voice');
				if (!voice) return;

				silenceItems.map(f => {
					voice.removeAttribute(f.option);
					if (f.exactSupported) {
						voice.removeAttribute(f.option + '-exact');
					}
				});

				silenceItems.filter(f => f.enabled).map(f => {
					voice.setAttribute(`${f.option}${f.exact ? '-exact' : ''}`, `${f.value}ms`);
				});

				this.editor().value = ssmlHelper.prepareSsml(doc.outerHTML, { ...this.record, sender: this })?.ssml;

				this.$refs.joditEditor.preformat();
			},
			onSayAsToolSave(ssml) {
				if (!ssml) return;
				ssml = `<mstts:silence type="Sentenceboundary-exact" value="0ms"/>${ssml}&nbsp;`;
				this.restoreSelection();
				if (this.editor().selection?.html) {
					this.editor().selection.insertHTML(ssml);
				} else {
					this.editor().value = ssmlHelper.prepareSsml(ssml, { ...this.record, sender: this })?.ssml;
				}
				this.$refs.joditEditor.preformat();
			},
			onVoiceConversionSave(audioLink) {
				if (!audioLink) return;
				let ssml = `<mstts:voiceconversion url="${audioLink}"/>&nbsp;`;
				this.restoreSelection();
				this.editor().selection.insertHTML(ssml);
				this.$refs.joditEditor.preformat();
			},
			onOverdubbingSave(opts) {
				if (__DEBUG__)
					console.debug('onOverdubbingSave', { opts });
				let replaceFull = false;
				if (opts?.voice) {
					if (this.selectedVoice?.id !== opts?.voice) {
						this.onVoiceSelect(this.voices.find(f => f.id === opts?.voice));
						this.replaceFull = true;
					}
				}
				if (replaceFull) {
					this.editor().value = opts?.ssml;
				} else {
					this.editor().selection.insertHTML(opts?.tag);
				}

				this.$refs.joditEditor.preformat();
			},
			onPronunciationToolSave(variant, selectedText, alphabet) {
				let text = alphabet ? `<phoneme alphabet="${(alphabet || 'ipa').toLowerCase()}" ph="${variant}">${(selectedText || '').trim()}</phoneme>` : variant;
				this.restoreSelection();
				this.editor().selection.insertHTML(text);
				this.$refs.joditEditor.preformat();
			},
			downloadSubTracksExcel() {
				if (this.isDownloadingExcelFile) return;
				this.isDownloadingExcelFile = true;
				this.$Data.getExternalApi('Creative/DownloadInsertionExcelFile', `parentInsertionId=${this.record.oid}`, void 0, void 0,  { responseType: 'blob' }).then(data => {
					if (__DEBUG__)
						console.debug('downloadSubTracksExcel response', { data });
					saveAs(data, 'Sub-tracks.xlsx');
				}).finally(() => this.isDownloadingExcelFile = false);
			},
			editSelectedWebService() {
				const dataButton = this.getTagButtons().find(f => f.name === 'data');
				if (dataButton) {
					dataButton.exec({
						wbsParams: {
							hideServiceSelection: true
						}
					});
				}
			},
			onJoditElemDblClick(tag) {
				if (__DEBUG__)
					console.debug('onJoditElemDblClick', { tag });
			},
			onJoditElemClick(tag, attribute, target, evt) {
				if (__DEBUG__)
					console.debug('onJoditElemClick', { tag, target, attribute, evt });

				this.editTag(tag, attribute, target, evt);
			},
			loadLexicons() {
				return this.$Data.loadLexicons(0, 999).then(r => {
					this.$set(this.joditLexicon, 'lexicons', r.Results || []);
					if (this.$refs.joditEditor)
						this.$refs.joditEditor.reloadEditor();
				});
			},
			loadStylizers() {
				return this.$Data.loadStylizers(0, 999).then(r => {
					this.$set(this.joditStylizer, 'styles', r.Results || []);
					if (this.$refs.joditEditor)
						this.$refs.joditEditor.reloadEditor();
				});
			},
			loadCustomTNs() {
				return this.$Data.loadCustomTNs(0, 999).then(r => {
					this.joditCustomTNs.lexicons = r.Results;
					if (this.$refs.joditEditor)
						this.$refs.joditEditor.reloadEditor();
				});
			},
			async validate(e, callback, additionalValidation) {
				if (!e.validationGroup?.validate || e.validationGroup.validate().isValid) {
					if (additionalValidation && !(await additionalValidation())) return;
					callback();
				}
			},
			getExtendedSelectionSsml(opts) {
				let editor = this.$refs.joditEditor && this.$refs.joditEditor.editor;

				if (!opts?.isEditor) {
					let node = this.applyEditTag({ virtual: true });
					let rootProsody = document.createElement('prosody');
					rootProsody.appendChild(node);
					return ssmlHelper.prepareSsml(rootProsody.outerHTML, { ...this.record, sender: this })?.ssml;
				}
				let selectionSsml = opts?.useCachedSelection ? this.$cachedSelection : editor?.selection?.html;
				let ssml = ssmlHelper.prepareSsml(`${this.record.ssml}`, { ...this.record, sender: this })?.ssml;
				let selectionStart = ssml.indexOf(selectionSsml);
				let selectionEnd = selectionStart + selectionSsml?.length;
				
				let hasSelectionText = !!$(`<div>${selectionSsml}</div>`).text();
				if (opts?.isEditor && hasSelectionText) {
					ssml = `${this.$refs.joditEditor?.editorWysiwyg?.html()}`;
					let startMarker = this.$refs.joditEditor?.editorWysiwyg.find('span[data-jodit-selection_marker=start]')[0]?.outerHTML;
					let endMarker = this.$refs.joditEditor?.editorWysiwyg.find('span[data-jodit-selection_marker=end]')[0]?.outerHTML;
					selectionStart = ssml.indexOf(startMarker) + startMarker?.length;
					selectionEnd = ssml.indexOf(endMarker);
					if (selectionEnd === -1 && selectionStart > -1) {
						selectionEnd = ssml.length-1;
					}
					selectionSsml = ssml.substr(selectionStart, selectionEnd - selectionStart);
				}
				if (__DEBUG__)
					console.debug('getExtendedSelectionSsml', { opts, selectionSsml, selectionStart, selectionEnd, ssml, hasSelectionText });

				if (!selectionSsml || selectionStart === -1 || !selectionEnd) return ssmlHelper.clearPreformat(ssml);

				let replaceTemplateText = '__REPLACE__ITEM__';
				let replaceTemplate = `<replaceitem>${replaceTemplateText}</replaceitem>`;
				let replaceTemplateTagClear = `<replaceitem></replaceitem>`;

				let leftPart = `${ssml.substr(0, selectionStart)}`.trim();
				let rightPart = `${ssml.substr(selectionEnd, ssml?.length)}`.trim();

				let joinedParts = `${leftPart}${replaceTemplate}${rightPart}`;
				let joinedPartsTagsOnly = ssmlHelper.replaceTextInHtml(joinedParts);

				const finalizeSsml = (ssml) => {
					var finalize = $('<div/>').append(ssml);
					finalize.find('span[data-jodit-selection_marker]').remove();
					return finalize[0].innerHTML;
				}

				if (opts?.isEditor) {
					let simpleSelectedSSMLSource = joinedPartsTagsOnly.replace(replaceTemplateTagClear, `${selectionSsml}`.trim());
					let simpleSelectedSSML = ssmlHelper.prepareSsml(finalizeSsml(simpleSelectedSSMLSource), { ...this.record, sender: this })?.ssml;

					if (__DEBUG__) {
						console.debug('getExtendedSelectionSsml 2', {
							selectionSsml,
							simpleSelectedSSML,
							simpleSelectedSSMLSource,
							joinedPartsTagsOnly,
							replaceTemplateTagClear,
							leftPart,
							rightPart
						});
					}

					if (!$('<div>').html(simpleSelectedSSML).text().length) {
						return ssmlHelper.clearPreformat(ssml);
					}

					return ssmlHelper.clearPreformat(simpleSelectedSSML);
				}

				let joinedPartsTextSplit = $('<div>').html(joinedParts).text().split(replaceTemplateText);
				let leftTextPart = `${joinedPartsTextSplit[0]}`.trim(' ');
				let rightTextPart = `${joinedPartsTextSplit[1]}`.trim(' ');

				if (leftTextPart.endsWith('.'))
					leftTextPart = '';

				let leftWord = _.last(`${leftTextPart}`.split(' ')) || '';
				let rightWord = _.first(`${rightTextPart}`.split(' ')) || '';

				let extendedText = joinedPartsTagsOnly.replace(replaceTemplateTagClear, `${leftWord.trim()} ${selectionSsml} ${rightWord.trim()}`.trim());

				extendedText = finalizeSsml(ssmlHelper.prepareSsml(extendedText, { ...this.record, sender: this })?.ssml);

				if (__DEBUG__) {
					console.debug('getExtendedSelectionSsml 3', {
						joinedPartsTagsOnly,
						leftTextPart,
						rightTextPart,
						leftWord,
						rightWord,
						selectionSsml,
						extendedText
					});
				}

				return ssmlHelper.clearPreformat(extendedText);
			},
			onCustomVoiceActive(voice, active) {
				if (active && voice?.id === this.record?.voice) {
					this.stopPlayCreative();
				}
			},
			onJoditPaste(value, fullReplace) {
				if (this._isDestroyed) return;
				if (__DEBUG__)
					console.debug('onJoditPaste', { value, fullReplace });
				if (fullReplace) {
					let sResult = this.getSsml(this.record, value);
					if (__DEBUG__)
						console.debug('onJoditPaste ssml', { sResult });
					this.ssml = sResult;
					this.editor().isSilentChange = true;
					this.editor().setEditorValue(sResult);
					this.syncData('ssml', 'onJoditPaste');
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.editor().isSilentChange = false;
					})
				} else {
					this.syncData('ssml', 'onJoditPaste');
				}
			},
			checkVoiceAccess(voice) {
				if (!voice)
					return true;
				const needPremiumSubscription = voice.isCustom && !voice.isCustomAvailable;
				if (needPremiumSubscription) {
					this.prePurchasePopupVisible = false;
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.prePurchasePopupVisible = true;
					});
					return false;
				}
				return true;
			},
			onVoiceSelect(voice, details) {
				if (this.checkVoiceAccess(voice)) {
					if (__DEBUG__)
						console.log('On voice select', { voice, details });

					this.activateVoice(voice, true, this.record.voiceStyle);
					this.updatingRecordValues = true;
					this.record.language = voice?.language?.locale;
					this.record.voice = voice?.id;
					this.record.ttsProviderType = voice?.voice?.TtsProviderType || 0;

					if (voice?.id) {
						storage.prop('ssmlVoice').value = voice?.id;
						storage.prop('ssmlLanguage').value = voice?.locale;
					}

					this.selectedVoiceDetails = details;

					setImmediate(() => {
						this.updatingRecordValues = false;
						this.syncData('record');
					});
				}
			},
			getVoiceDetails(voice) {
				this.voiceDetailsLoading = true;
				return this.$Data
					.getExternalApi(
						'Voice/GetVoiceDetails',
						`voiceId=${voice.voice.Oid}`)
					.then((details) => {
						this.selectedVoiceDetails = details;

						if (!this.voiceRestrictedIabCategories.length
							|| (this.creativeIabCategories?.length > 0 && !this.matchedIabCategories.length)) {
							if (voice) this.onVoiceSelect(voice, details);
						}

						this.voiceDetailsLoading = false;
					});
			},
			startPlayCreative(solo, isEditor, preload, callback, useCachedSelection) {
				this.playCreative(solo, callback, {
					ssml: this.getExtendedSelectionSsml({ isEditor, useCachedSelection })
				}, preload);
			},
			playOriginal() {
				this.startPlayCreative(true, true, void 0, void 0, true);
			},
			purchaseSubscription() {
				this.prePurchasePopupVisible = false;
				this.$refs.SubscriptionPopup.show(true);
			},
			saveSSML() {
				if (__DEBUG__)
					console.debug('Save SSML');
				this.$savedSSML = this.isSSML ? this.record.pureSSML : this.ssml;
			},
			restoreSSML(clear) {
				if (this.$savedSSML) {
					if (__DEBUG__)
						console.debug('Restore SSML');
					if (this.isSSML)
						this.record.pureSSML = this.$savedSSML;
					else {
						this.ssml = this.$savedSSML;
						this.record.ssml = this.$savedSSML;
						this.editor().value = this.$savedSSML;
					}

					if (clear) {
						delete this.$savedSSML;
					}
				}
			},
			setMode(mode) {
				setTimeout(() => {
					switch (mode) {
						case 'text':
							this.isSSML = false;
							delete this.record.pureSSML;
							break;
						case 'ssml':
							this.record.pureSSML = this.getSsml(this.record, this.ssml);
							if (__DEBUG__)
								console.debug('SetMode');
							this.isSSML = true;
							break;
					}
				}, 100);
			},
			onPureSSMLChanged(v) {
				if (__DEBUG__)
					console.debug('On pure SSML changed', { v });
				this.ssml = v;
				this.record.pureSSML = v;
				this.syncData('ssml', 'onPureSSMLChanged');
			},
			resetSsml() {
				this.$confirm(void 0, this.$tCaption('Do you want to reset changes?')).then(() => {
					this.record.pitch = 1;
					this.record.rate = 1;
					let div = $('<div />').append(this.record.ssml);
					div.find('*').each((i, item) => {
						if (item.childNodes?.length) {
							item.after(...item.childNodes);
						}
						item.remove();
					});
					
					this.ssml = ssmlHelper.prepareSsml(div[0] && div[0].innerHTML, { ...this.record, sender: this })?.ssml;
					if (this.isSSML) {
						this.syncData('ssml', 'resetSsml');
					}
				});
			},
			save() {
				this.$emit('save', this.record);
				if (this.updatedTags && Object.keys(this.updatedTags)) {
					this.$emit('update-tags', Object.keys(this.updatedTags).map(f => this.updatedTags[f]), [this.record.oid]);
				}
			},
			remove() {
				this.$emit('remove', this.record);
			},
			stopPlayCreative() {
				this.isPlaying = 0;
				this.stop();
				this.$emit('stopAll');
			},
			doPreloadAudio() {
				if (this.isPlaying) return;

				this.$isAudioPreloading = (this.$isAudioPreloading || 0) + 1;

				if (this.$isAudioPreloading > 1) return;
				this.startPlayCreative(true, true, true, () => {
					if (this.$isAudioPreloading > 2) {
						this.$isAudioPreloading = 0;
						this.doPreloadAudio();
					} else {
						this.$isAudioPreloading = 0;
					}
				});
			},
			playCreative(solo, callback, customData, preload) {
				if (__DEBUG__)
					console.debug('PlayCreative', { solo, customData, preload });

				if (!preload) {
					this.isPlaying = solo ? 1 : 2;
				} else {
					this.isPreloading = true;
				}
				this.$emit('loadAudio',
					{ ...this.record, ...(customData || {}) },
					(promise) => {
						promise
							.then((data) => {
								if (this._isDestroyed || (!preload && !this.isPlaying)) return;
								if (__DEBUG__)
									console.info('Audio loaded', this.record.buffer);

								this.record.dynamicSsmlResult = data.record?.dynamicSsmlResult;
								this.record.rate = data.record?.rate || this.record.rate || 1;
								this.record.buffer = data.record?.buffer;
								this.record.base64 = data.record?.base64;
								this.record.requestHashKey = data.record?.requestHashKey;
								this.record.lastTtsLogId = data.record?.lastTtsLogId || this.record.lastTtsLogId;

								if (__DEBUG__)
									console.debug('PlayCreative decoded', data);
								let tracks = [];
								let trackId = this.track && this.track.id || this.$Data.uuid();
								if (!(this.track && this.track.id) || solo) {
									tracks.push({
										id: trackId,
										playbackRate: this.track.playbackRate,
										pitchRate: this.track.pitchRate
									});
								}

								let trackBuffers = {};
								trackBuffers[trackId] = data.buffer;

								if (!preload) {
									this.tracker.play(this.track && this.track.start, {
										trackBuffers,
										tracks,
										duration: data.buffer.duration,
										solo,
										forcePlayTracks: [trackId],
										onStop: () => {
											this.isPlaying = 0;
											if (callback)
												callback();
										}
									});
								} else {
									if (callback)
										callback();
								}
							})
							.catch(() => {
								this.isPlaying = 0;
								if (callback)
									callback();
							})
							.finally(() => {
								this.isPreloading = false;
							});
					});
			},
			stop() {
				if (this.$audio)
					this.$audio.pause();
			},
			loadRules(pageIndex, limit, opts) {
				return Data.getRules(pageIndex, limit, opts);
			},
			lockEditor(val) {
				let editor = this.$refs.joditEditor && this.$refs.joditEditor.editor;
				if (editor) {
					val ? editor.lock() : editor.unlock();
				}
			},
			selectNLCSound(id) {
				if (id) {
					this.editingNodeInfo.values.id = id;
					this.editingNodeInfo.values.type = this.selectedVoiceNLCSounds.find((s) => s.Oid === id)?.NlcsType?.Description;
					this.editingNodeInfo.values.intensity = parseInt(this.selectedVoiceNLCSounds.find((s) => s.Oid === id)?.NlcsIntensity) || 0;
					this.editingNodeInfo.values.azureFile = this.selectedVoiceNLCSounds.find((s) => s.Oid === id)?.AzureFile;
				}
			},
			playNLCSound() {
				const audio = new Audio(this.editingNodeInfo.values.azureFile);
				audio.play();
			},
			onSelectedVoice(v) {
				this.selectedVoice = v;
				this.isJoditRendered = false;

				if (!this.selectedVoiceDetails && this.selectedVoice?.voice?.Oid) {
					this.getVoiceDetails(this.selectedVoice);
				}

				if (this.isRTL) {
					Object.assign(
						this.joditConfig,
						{
							direction: 'rtl',
							language: this.recordLanguage.split('-')[0],
						}
					)
				} else {
					if (this.joditConfig.direction)
						delete this.joditConfig.direction;
					if (this.joditConfig.language)
						delete this.joditConfig.language;
				}

				this.$nextTick(() => {
					this.isJoditRendered = true;
					this.setDefaults();
				});
			},
			updateIabCategories() {
				this.$eventsBus.$emit('update-iab-categories');
			},
		}
	};
</script>

<style lang='scss'>
	.audio-tracker-insertion--details {
		.layout-main {
			> .left {
				flex: 4;
				flex-basis: 500px;
			}

			> .right {
				flex: 2;
				flex-basis: 200px;
			}
		}

		.ssml-actions-button {
			.dx-button-mode-text.dx-button-default .dx-icon {
				color: #777;
				font-size: 18px;
			}

			.dx-button-has-icon .dx-button-content {
				padding: 2px;
			}

			.dx-button {
				height: 30px;
				min-width: 30px;
			}
		}

		.insertion-info {
			max-width: 320px;
		}
	}

	.NLCSounds {
		.loader-icon {
			font-size: 40px;
			color: #f27649;
		}
	}
</style>
